import * as Actions from 'store/actions/app/supplier_order_items.actions'
import { toggleIdInArray } from 'utils/toggle-id-in-array'

const initialState = {
  loading_items_by_supplier_order: false,
  items_by_supplier_order: [],

  saving_supplier_order_items: false,
  saved_supplier_order_items: false,

  removing_product_request_ids: [],
  removed_product_request_ids: [],

  removing_supplier_order_item_ids: [],
  removed_supplier_order_item_ids: [],
}

export default function supplierOrderItemsReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.GET_ITEMS_BY_SUPPLIER_ORDER_ID: {
      return {
        ...state,
        loading_items_by_supplier_order: action.payload.loading,
        items_by_supplier_order: action.payload.data ?? state.items_by_supplier_order,
      }
    }
    case Actions.SAVE_SUPPLIER_ORDER_ITEMS: {
      return {
        ...state,
        saving_supplier_order_items: action.payload.saving,
        saved_supplier_order_items: action.payload.saved,
        items_by_supplier_order: Array.isArray(action.payload.data)
          ? action.payload.data
          : state.items_by_supplier_order,
      }
    }
    case Actions.REMOVE_PRODUCT_REQUEST: {
      return {
        ...state,
        removing_product_request_ids: toggleIdInArray(state.removing_product_request_ids, action.payload.removing_id),
        removed_product_request_ids: toggleIdInArray(state.removed_product_request_ids, action.payload.removed_id),
      }
    }
    case Actions.REMOVE_SUPPLIER_ORDER_ITEM: {
      return {
        ...state,
        removing_supplier_order_item_ids: toggleIdInArray(state.removing_supplier_order_item_ids, action.payload.removing_id),
        removed_supplier_order_item_ids: toggleIdInArray(state.removed_supplier_order_item_ids, action.payload.removed_id),
        items_by_supplier_order: state.items_by_supplier_order.filter(item => item.orden_proveedor_detalle_id !== action.payload.removed_id)
      }
    }
    default: {
      return state
    }
  }
}
